import { ReactNode } from "react";

import { Switch } from "../../stories/Switch/Switch";
import { Accordion } from "../../stories/Accordion/Accordion";
import { useNavigate, useParams } from "react-router-dom";
import { AnatomyItem } from "../../types/interfaces";
import { ItemType } from "../../types/enums";

const MultiCharacteristicsWrapper = (props: {
  isMultipleCaracteristicsByItem: boolean;
  setIsMultipleCaracteristicsByItem: (value: boolean) => Promise<void>;
  children: (item: any) => ReactNode;
  items: AnatomyItem[];
  openedPanelMultiCharacteristics: string;
  setOpenedPanelMultiCharacteristics: (title: string) => void;
  savedMultiCharacteristicsItems: number[];
}) => {
  const navigate = useNavigate();
  const { order_id } = useParams();

  const isItemAlreadySaved = (
    itemTeethAlreadySaved: number[],
    itemTeeth: number[]
  ) => {
    if ((itemTeeth ?? []).length === 0) {
      return false;
    }
    return itemTeethAlreadySaved.includes(itemTeeth[0]);
  };

  const sortByTeeth = (a: AnatomyItem, b: AnatomyItem) => {
    if ((a.teeth ?? []).length === 0 || (b.teeth ?? []).length === 0) {
      return 0;
    }
    return a.teeth[0] - b.teeth[0];
  };

  return (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ paddingBottom: "0.5rem" }}>
          <Switch
            label="Characteristics different by item"
            checked={props.isMultipleCaracteristicsByItem}
            onChange={async (value: boolean) =>
              await props.setIsMultipleCaracteristicsByItem(value)
            }
          />
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => navigate(`/orders/${order_id}/edit/`)}
        >
          Go back to order products
        </div>
      </div>
      {props?.isMultipleCaracteristicsByItem ? (
        <Accordion
          opened={props.openedPanelMultiCharacteristics}
          setOpened={(title: string) => {
            if (title === props.openedPanelMultiCharacteristics) {
              props.setOpenedPanelMultiCharacteristics("");
              return;
            }
            props.setOpenedPanelMultiCharacteristics(title);
          }}
          items={(props.items ?? [])
            .toSorted((a, b) => sortByTeeth(a, b))
            .filter(item => {
              if (item.itemType === ItemType.CROWN) {
                const findTenon = (props.items ?? []).find(itemComp => {
                  if (
                    itemComp.teeth instanceof Array &&
                    item.teeth instanceof Array
                  ) {
                    return (
                      JSON.stringify(itemComp.teeth) ===
                        JSON.stringify(item.teeth),
                      itemComp.itemType === ItemType.INLAY_CORE
                    );
                  }
                  return (
                    itemComp.teeth.join("") === item.teeth.join("") &&
                    itemComp.itemType === ItemType.INLAY_CORE
                  );
                });
                if (findTenon) {
                  return false;
                }
              }
              return true;
            })
            .map((item: AnatomyItem): { value: string; content: ReactNode } => {
              return {
                value: `${item?.itemType.replaceAll("_", " ")} ${item?.teeth} ${isItemAlreadySaved(props.savedMultiCharacteristicsItems, item.teeth) ? "✅" : ""} ${!item?.itemMaterial ? "❌" : ""}`,
                content: props.children(item),
              };
            })}
        />
      ) : (
        <>{props.children(props.items)}</>
      )}
    </>
  );
};

export default MultiCharacteristicsWrapper;
